export {
  baseMetadata,
  baseViewport,
  localeAlternates,
  pageMetadata,
  SEO_SCRIPTS,
  SITE,
  BRAND,
  YANDEX_METRIKA_ID,
} from './metadata';
